module.exports = __webpack_public_path__ + "img/a2-s14.87b43fe5.jpg";